import styled from 'styled-components'
import { ReactSVG } from 'react-svg'
import ReactTooltip from 'react-tooltip'

import { fontSizeResponsive, mediaQ } from '../../theme/mixins'

export const NavigationBarContainer = styled.div`
  height: 11.5vh;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.16);
  /* position: relative; */
  width: 100%;
  border-bottom: ${(props) =>
    props.isNavDropdownVisible ? '1px solid rgba(0, 0, 0, 0.16)' : 'unset'};
  display: flex;
  align-items: center;

  background-color: white;

  ${mediaQ(
    'mobileAll',
    'position:fixed;bottom:0;height: 9.5vh;width: 100%;justify-content: space-around;z-index:12;'
  )};
`
export const NavElement = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  margin-left: ${(props) => (props.settings ? 'auto' : 'unset')};
  display: flex;

  flex-direction: column;
  justify-content: center;
  div {
    display: flex;
    justify-content: center;
  }
  svg {
    width: 100%;
    height: 100%;
  }

  &.settings {
    ${mediaQ('mobileAll', 'position: fixed;top: 8vh;right: 3vw;')};
  }

  ${mediaQ('mobileAll', 'width:unset; padding:5px; margin: 0px;')};
`

export const Tooltip = styled(ReactTooltip)`
  font-family: 'Open Sans';
  font-weight: 600;
  line-height: 15px;
  max-width: 500px;

  ${mediaQ('mobileAll', 'display: none;')}
`

export const SvgElement = styled(ReactSVG)`
  fill: #fe0d9f;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  filter: ${(props) =>
    props.isDisabled ? 'blur(1px) grayscale(100%)' : 'unset'};

  #color1 {
    stop-color: #fe0d9f;
  }
  #color2 {
    stop-color: #fe0d9f;
  }
  opacity: ${(props) => (props.settings || props.diet ? '1' : '0.5')};

  &:hover {
    #color1 {
      stop-color: #faae01;
    }
    #color2 {
      stop-color: #fe0da0;
    }
    opacity: 1;
    cursor: pointer;
  }
`
export const NavElementName = styled.span`
  font-family: 'Roboto';
  margin-top: 8px;
  ${fontSizeResponsive(16)}
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`
